<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Edit Estimate Type
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-8">
          <b-form-group :label-cols="4" label="Estimate Type" label-align="right">
            <b-form-radio-group v-model="selfPaySelected" class="pt-2" :options="selfPayOptions" stacked/>
          </b-form-group>
            <b-form-group v-if="!selfPaySelected && patInsurances.length > 1" :label-cols="4"
                          label="Insurance"
                          :state="stateForField('organizationPatientInsuranceId')"
                          :invalid-feedback="errorForField('organizationPatientInsuranceId')"
                          label-class="text-right">
              <b-dropdown  menu-class="dropdown-container" :text="insuranceName"
                           :variant="hasError('organizationPatientInsuranceId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="insurance in patInsurances" :key="insurance.organizationPatientInsuranceId"
                                 @click.prevent="setInsurance(insurance)"
                >{{ insurance.insuranceCompany }}, {{ insurance.insurancePriority }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <div class="row" v-if="patInsurances.length === 1 && !selfPaySelected">
                <div class="col-4 pr-1 text-right">Insurance Plan</div>
                <div class="col-4"><strong>{{ insurances[0].insuranceCompany }}</strong></div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>

  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'EditEstimateTypeModal',

    mixins: [ErrorsMixin, AnalyticsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      isSelfPay: {
        type: Boolean,
        required: true
      },

      insurances: {
        type: Array,
        required: false
      }
    },

    data () {
      return {
        selfPaySelected: false,
        selfPayOptions: [
          { value: false, text: 'Fee for Service' },
          { value: true, text: 'Self Pay' }
        ],
        insuranceOptions: [],
        insuranceSelected: {},
        patInsurances: [],
        insuranceName: 'Click to select'
      }
    },

    watch: {
      isSelfPay (newValue, oldValue) {
        if (newValue) {
          this.selfPaySelected = newValue
        }
      },

      insurances (newValue) {
        if (newValue) {
          this.patInsurances = newValue
        }
      }
    },

    methods: {
      save () {
        this.$emit('estimateTypeUpdated', this.selfPaySelected, this.insuranceSelected)
      },

      setInsurance (insurance) {
        this.insuranceSelected = insurance
        this.insuranceName = insurance.insurancePlan
      },

      closeModal () {
        this.trackEvent('Estimate', 'EditTypeModal', 'Closed')
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

</style>
